module.exports = __webpack_public_path__ + "static/img/yop.2d248e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yop.png
// module id = Fixu
// module chunks = 1